import { queryOptions } from "@tanstack/react-query";
import { apiClient, orgHeader, unwrap } from "../../../api/client";

export const PENDING_MS = 10_000;

/** The device's settings with desired, reported and their state (WEB-SET-01). */
export const settingsQuery = (orgId: string, device: string, enabled = true) =>
  queryOptions({
    queryKey: ["org", orgId, "/v1/devices/{device_id}/settings", device],
    queryFn: () =>
      unwrap(
        apiClient("customers").GET("/v1/devices/{device_id}/settings", {
          params: { path: { device_id: device }, header: orgHeader(orgId) },
        }),
      ),
    enabled,
    // A pending change is read again until the device confirms it.
    refetchInterval: (q) => (q.state.data?.items.some((s) => s.state === "pending") ? PENDING_MS : false),
  });

/** The device's latest commands and setting changes, newest first (WEB-CMD-06). */
export const commandsQuery = (orgId: string, device: string) =>
  queryOptions({
    queryKey: ["org", orgId, "/v1/devices/{device_id}/commands", device],
    queryFn: () =>
      unwrap(
        apiClient("customers").GET("/v1/devices/{device_id}/commands", {
          params: { path: { device_id: device }, query: { limit: 10 }, header: orgHeader(orgId) },
        }),
      ),
  });
